module.exports = __webpack_public_path__ + "img/spiel1.fbde8a6c.jpg";